const fileExtensionsToMimeType = {
  psa: "text/psa",
  json: "application/json",
  csv: "text/csv",
};

export const downloadFile = ({
  name,
  extension,
  data,
}: {
  name: string;
  extension: "psa" | "json" | "csv";
  data: string;
}) => {
  const file = document.createElement("a");
  file.style.display = "none";

  // PSA files must carry a UTF-8 BOM — some Space Planning builds silently
  // render plain-UTF-8 files as blank.
  const BOM = String.fromCharCode(0xfeff);
  const payload = extension === "psa" && !data.startsWith(BOM) ? BOM + data : data;

  file.setAttribute(
    "href",
    `data:${fileExtensionsToMimeType[extension]};charset=utf-8,${encodeURIComponent(payload)}`,
  );
  file.setAttribute("download", `${name}.${extension}`);

  document.body.appendChild(file);
  file.click();
  document.body.removeChild(file);
};

export const downloadBlob = (blob: Blob, filename: string): void => {
  const blobUrl = URL.createObjectURL(blob);
  const file = document.createElement("a");
  file.style.display = "none";
  file.href = blobUrl;
  file.download = filename;
  document.body.appendChild(file);
  file.click();
  document.body.removeChild(file);
  URL.revokeObjectURL(blobUrl);
};

export const openNativeDownload = (url: string): void => {
  const file = document.createElement("a");
  file.href = url;
  file.rel = "noopener";
  document.body.appendChild(file);
  file.click();
  file.remove();
};

export const downloadFileFromUrl = async (url: string) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to fetch file");

    const blob = await response.blob();
    const fileNamePieces = url.split("/");
    const fileName = fileNamePieces[fileNamePieces.length - 1].split("?")[0];
    downloadBlob(blob, fileName);
  } catch (error) {
    console.error("Download failed:", error);
  }
};
